export default __webpack_public_path__ + "assets/images/callback-spring-25b398d0.png";